import React from 'react'
import PropTypes from 'prop-types'
import { generatePath } from 'react-router-dom'
import { PAYMENT_PRINT } from 'constants/app-paths'
import { Button } from 'ui-components/Button'

export default function PrintPaymentButton({ paymentId }) {
  const printPayment = () => {
    const path = generatePath(PAYMENT_PRINT, { id: paymentId })
    window.open(path, '_blank').focus()
  }

  return (
    <Button
      color="primary"
      onClick={printPayment}
    >
      Imprimir
    </Button>
  )
}

PrintPaymentButton.propTypes = {
  paymentId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
}
